import {
  CALENDAR_EVENTS_PAGE_SIZE,
  type CalendarEventsPageInput,
  type CalendarEventsResponse,
} from "@site-types/calendar"
import { createServerFn } from "@tanstack/react-start"
import * as z from "zod"

const calendarEventsPageInputSchema = z.object({
  limit: z.number().int().min(1).max(CALENDAR_EVENTS_PAGE_SIZE).optional(),
  offset: z.number().int().min(0).optional(),
})

function serverFnPayload<T>(value: T): never {
  return value as never
}

const getCalendarEventsPageData = createServerFn({ method: "GET" })
  .validator((input: unknown) => calendarEventsPageInputSchema.parse(input))
  .handler(async ({ data }) => {
    const { getCalendarEventsPage } = await import("@data/events-data")
    return serverFnPayload(await getCalendarEventsPage(data as CalendarEventsPageInput))
  })

export async function loadCalendarEventsPage(
  input: CalendarEventsPageInput
): Promise<CalendarEventsResponse> {
  return (await getCalendarEventsPageData({ data: input })) as CalendarEventsResponse
}
